import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import messages from '../../../locale/jsonMessages';
import { formatInspectionStatus } from '../../../helpers/inspectionPresentation';
import s from '../Inspection.css';

export const TONE_CLASS = { success: 'toneSuccess', warning: 'toneWarning', danger: 'toneDanger', info: 'toneInfo', neutral: 'toneNeutral' };
export const ICONS = { ok: '✓', alert: '!', clock: '◷', edit: '✎', minus: '−' };

// Status badge: always an icon AND a text (the colour is never the only signal). Give either a stored `status`
// (not_done / draft / to_validate / validated) or an `entry` built by getInspectionEntry.
export function InspectionStatusBadge({ status, entry, label, intl, className }) {
  const view = entry || formatInspectionStatus(status);
  const text = label || intl.formatMessage(messages[view.labelKey]);
  return (
    <span className={cx(s.badge, s[TONE_CLASS[view.tone] || 'toneNeutral'], className)}>
      <span className={s.badgeIcon} aria-hidden="true">{ICONS[view.icon] || ''}</span>
      <span>{text}</span>
    </span>
  );
}

InspectionStatusBadge.propTypes = {
  status: PropTypes.string,
  entry: PropTypes.shape({ labelKey: PropTypes.string, tone: PropTypes.string, icon: PropTypes.string }),
  label: PropTypes.string,
  className: PropTypes.string
};

export default injectIntl(withStyles(s)(InspectionStatusBadge));
